<template>
  <div class="image-container">
    <h1 class="home-title">{{$t("Welcome to your SMR platform")}}</h1>
    <img src="/img/accueil.jpeg" class="img-responsive">
  </div>
</template>

<script>
export default {
  name: "Home"
}
</script>

<style lang="scss">
.img-responsive {
  opacity: 0.5;
  object-fit: cover;
  width: 100vw;
  height: 100vh;
}
.home-title {
  position: absolute;
  z-index: 10;
  font-size: 50px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: underline;
}
.image-container {
  margin-left: -32px;
  width: calc(100% + 65px);
  position: relative;
  margin-bottom: 4em;
}
</style>

